import { transparentGif } from '~/utils/constants';
import { getCachedImage } from '~/utils/imageCache';

export class CacheImg extends HTMLElement {
  static observedAttributes = ['data-key'];
  #loaded = false;
  #onclick: string | null = null;

  connectedCallback() {
    this.#onclick = this.getAttribute('onclick');
    if (this.#onclick) this.removeAttribute('onclick');
    void this.load();
  }

  attributeChangedCallback() {
    if (this.#loaded) void this.load();
  }

  async load() {
    this.#loaded = true;
    const key = this.getAttribute('data-key');
    if (!key) return;

    const img = document.createElement('img');
    const style = this.getAttribute('style');
    if (style) img.setAttribute('style', style);

    if (this.#onclick) img.setAttribute('onclick', this.#onclick);

    try {
      const url = await getCachedImage(key);
      img.src = url ?? transparentGif;
    } catch {
      img.src = transparentGif;
    }

    img.onerror = () => {
      img.onerror = null;
      img.src = transparentGif;
    };

    this.replaceChildren(img);
  }
}

if (typeof customElements !== 'undefined' && !customElements.get('cache-img')) {
  customElements.define('cache-img', CacheImg);
}
